export default __webpack_public_path__ + "static/media/invalid.1ff6059a.svg";